import { Content } from "pdfmake/interfaces";
import gap from "report/common/gap";
import layout from "report/common/layout";

const get = (table: string, title: string, row: any[]): Content[] => {
  return [
    {
      text: [
        { text: table, bold: true }, // 前两个字加粗，加右边间距
        { text: title } // 其余部分不加粗
      ],
      fontSize: 14,
      margin: [0, 0, 0, 8],
      opacity: 0.87
    },
    {
      table: {
        headerRows: 0,
        widths: [12, 100, 30, "*", "*", "*", "*", "*", "*", "*", "*", "*"],
        body: [
          [
            { text: "" },
            { text: "" },
            { text: "" },
            { text: "2030" },
            { text: "2035" },
            { text: "2040" },
            { text: "2045" },
            { text: "2050" },
            { text: "2055" },
            { text: "2060" },
            { text: "2070" },
            { text: "2085" }
          ],
          ...row
        ]
      },
      layout: layout(),
      fontSize: 7,
      alignment: "center"
    },
    gap(10)
  ];
};

export default get;
